var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.207,
    viewBox: "0 0 18 18.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_update",
    "data-name": "icona update",
    transform: "translate(-3834 -3581.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icona",
    d: "M19.876,12.568a.613.613,0,0,0-.621.546,6.653,6.653,0,0,1-6.742,5.943,6.639,6.639,0,0,1-6.767-6.485,6.632,6.632,0,0,1,6.592-6.485.16.16,0,0,1,.171.161V8.269a.669.669,0,0,0,1.025.542l4.009-2.7a.63.63,0,0,0,0-1.089l-4-2.668a.669.669,0,0,0-1.025.542V4.729a.161.161,0,0,1-.163.161A7.848,7.848,0,0,0,4.5,12.572a7.85,7.85,0,0,0,8.013,7.678A7.874,7.874,0,0,0,20.5,13.215a.607.607,0,0,0-.621-.647Z",
    transform: "translate(3830.5 3579.749)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2151",
    "data-name": "Tracciato 2151",
    d: "M23099.012,6428.9v3.45l3,2.063",
    transform: "translate(-19255.941 -2839)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_838",
    "data-name": "Rettangolo 838",
    transform: "translate(3834 3582)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.6a6b9bbaf8b44b16275a17656b412693.svg";
export { ForwardRef as ReactComponent };